import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const fadeInOutAnimation = trigger('fadeInOut', [
  state('void', style({ opacity: 0 })),
  transition(':enter', [
    // Fade in
    animate('150ms ease-in', style({ opacity: 1 })),
  ]),
  transition(':leave', [
    // Fade out
    animate('150ms ease-out', style({ opacity: 0 })),
  ]),
]);
